/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { Alert, Button, Card, Col, Row, Form, Select, Space, Input, Modal } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'
import InstitutionUserService from '../../services/InstitutionUserService'

const { Option } = Select

const EditBailiffRefundRequestStatus = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const refundRequest = state || {}
  const bailiffRefundRequest = state || {}
  const [form] = Form.useForm()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [statusData, setStatusData] = useState<any>({})
  const [isEdit, setIsEdit] = useState(false)
  const [editStatusID, setEditStatusID] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const location = useLocation()
  const formatDate = ({ dateString }: { dateString: any }) => {
    if (!dateString) return '-'
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return '-'
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    if (location.state != null) {
      const { status_id, status } = location?.state
      setIsEdit(true)
      setEditStatusID(status_id)
      form.setFieldsValue({ status, reason: null })
    }
  }, [form, location.state])

  const showModal = (): void => {
    setIsModalOpen(true)
  }

  const handleModalOk = (): void => {
    setLoading(true)
    updateRefundStatus()
      .then(() => {
        setError(null)
        Modal.success({
          title: 'Success',
          content: 'The refund request status has been updated successfully.'
        })
        navigate('/bank-transfer-update-status')
      })
      .catch((err: any) => {
        const backendMessage = err?.message || 'Failed to update refund request status.'
        setError(backendMessage)
        Modal.error({
          title: 'Error',
          content: backendMessage
        })
      })
      .finally(() => {
        setLoading(false)
        setIsModalOpen(false)
      })
  }

  const updateRefundStatus = async (): Promise<void> => {
    try {
      const transactionReference = refundRequest.transaction_reference
      const selectedStatus = form.getFieldValue('status')
      const reason = (form.getFieldValue('reason') ?? '').trim()

      if (!transactionReference || !selectedStatus || reason.length === 0) {
        throw new Error('Missing required fields to update refund status.')
      }

      const phoneNumber =
        refundRequest.phone_number ||
        refundRequest.bidder_phone_number ||
        refundRequest.bailiff_phone_number

      const payload = {
        BailiffRefundRequest: [
          {
            transaction_reference: transactionReference,
            bailiff_refund_request_id: refundRequest.bailiff_refund_request_id,
            phone_number: phoneNumber,
            bidder_phone_number: refundRequest.bidder_phone_number,
            bailiff_phone_number: refundRequest.bailiff_phone_number
          }
        ],
        status: selectedStatus,
        reason
      }
      const response = await InstitutionUserService.editBailiffRefundRequestStatusMessage(payload)
      if (response?.status !== 200 || !Array.isArray(response?.data) || response.data.length === 0) {
        throw new Error(response?.message ?? 'No bailiff refund request was updated.')
      }
    } catch (err) {
      if (err instanceof Error) {
        throw err
      }
      throw new Error('Failed to update refund request status.')
    }
  }

  const handleModalCancel = (): void => {
    setIsModalOpen(false)
  }

  const onFinish = (values: any): void => {
    showModal()
    setStatusData(values)
  }
  return (
    <div className="w-full p-6 bg-gray-50">
      <style>{
        `
        .enhanced-card {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
        }
        .enhanced-card:hover {
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          transform: translateY(-2px);
        }
        .section-header {
          background: linear-gradient(135deg, #37762f 0%, #4a7c59 100%);
          color: white;
          padding: 12px 16px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 16px;
        }
        `
      }</style>

      <div className="px-5 py-4 border-b border-gray-300" style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        borderRadius: '0 0 12px 12px',
        marginBottom: '20px',
      }}>
        <div className="flex justify-between items-center">
          <div className="text-title font-semibold text-gray-800">
            <span
              className="cursor-pointer text-blue-600 hover:text-blue-700"
              onClick={() => navigate('/bank-transfer-update-status')}
            >
              Bank Transfer Update Status
            </span>
            {' > '}
            <span className="font-medium text-gray-600">{refundRequest?.beneficiary_account_name || 'Bailiff Refund Request'}</span>
          </div>
        </div>
      </div>

      <div className="px-7 py-4 enhanced-card">
        <div className="section-header">Beneficiary Refund Request Details</div>
        <Row gutter={[16, 16]}>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Beneficiary Account Name</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.beneficiary_account_name || '-'}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Beneficiary Bank Name</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.beneficiary_bank_name || '-'}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Beneficiary Account Number</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.beneficiary_account_number || '-'}</div>
          </Col>
        </Row>
        <Row gutter={[16, 16]} className="pt-4">
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Debit Account Number</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.debit_account_number || '-'}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Debit Account Name</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.debit_account_name || '-'}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Transaction Reference</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.transaction_reference || '-'}</div>
          </Col>
        </Row>
        <Row gutter={[16, 16]} className="pt-4">
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Amount to be Refunded</div>
            <div className="text-base font-medium text-gray-500">
              {refundRequest?.amount ? parseInt(String(refundRequest?.amount), 10).toLocaleString() : '-'}
            </div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Transaction Currency</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.transaction_currency || '-'}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Current Status</div>
            <div className="text-base font-semibold text-blue-600">{refundRequest?.status || '-'}</div>
          </Col>
        </Row>
        <Row gutter={[16, 16]} className="pt-4">
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Requested Date</div>
            <div className="text-base font-medium text-gray-500">{formatDate({ dateString: refundRequest?.created_at })}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Updated Date</div>
            <div className="text-base font-medium text-gray-500">{formatDate({ dateString: refundRequest?.updated_at })}</div>
          </Col>
        </Row>
      </div>

      <div className="px-7 py-4 mt-6 enhanced-card">
        <div className="section-header">Update Refund Request Status</div>
        {error && (
          <Alert
            className="mb-4"
            message="Update failed"
            description={error}
            type="error"
            showIcon
          />
        )}
        <Form
          name="status_form"
          layout="vertical"
          className="status-form p-2"
          initialValues={{
            status: refundRequest?.status,
            reason: null
          }}
          onFinish={onFinish}
          form={form}
        >
          <Space direction="vertical" size={5} className="w-full">
            <Card className="enhanced-card h-full" style={{ background: '#fff' }}>
              <Row gutter={[16, 16]}>
                <Col xs={24} md={24} xl={24}>
                  <Form.Item
                    name="status"
                    label="Status"
                    rules={[{ required: true, message: 'Please select a status' }]}
                  >
                    <Select placeholder="Choose the new status">
                      <Option value="Bank Transfer Failed">Bank Transfer Failed</Option>
                      <Option value="RECEIVED REQUEST">RECEIVED REQUEST</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={24} xl={24}>
                  <Form.Item
                    name="reason"
                    label="Reason"
                    rules={[{ required: true, message: 'Please enter reason' }]}
                  >
                    <Input.TextArea
                      rows={4}
                      maxLength={300}
                      showCount
                      placeholder="Type clear reason for the status update"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  style={{
                    background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
                    border: 'none',
                    borderRadius: '8px',
                    height: '40px',
                    fontSize: '16px',
                    fontWeight: '600'
                  }}
                >
                  {isEdit ? 'Update Status' : 'Submit Status'}
                </Button>
              </Form.Item>
            </Card>
          </Space>
        </Form>

        <Modal
          title={
            <div style={{
              background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
              color: 'white',
              padding: '12px 16px',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              margin: '-8px 0 0 0'
            }}>
              {isEdit ? 'Confirm Status Update' : 'Confirm Status Submission'}
            </div>
          }
          open={isModalOpen}
          onOk={handleModalOk}
          onCancel={handleModalCancel}
          confirmLoading={loading}
          okText={isEdit ? 'Yes, Update Status' : 'Yes, Submit Status'}
          cancelText="Cancel"
        >
          <div className="enhanced-card p-4" style={{
            background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
            marginTop: '8px'
          }}>
            <p className="text-gray-700 font-medium mb-2">
              Are you sure you want to {isEdit ? 'update' : 'submit'} this status?
            </p>
            <p className="text-gray-600 mb-0">
              New status: <span className="font-semibold text-blue-600">{form.getFieldValue('status') || '-'}</span>
            </p>
          </div>
        </Modal>
      </div>
    </div>
  )
}

export default EditBailiffRefundRequestStatus
